import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const CatchupAvailabilityText = styled.span`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${30 * Screen.widthRatio}px;
`;

export default CatchupAvailabilityText;
